import React, { useState } from 'react';
import { MapPin, X } from 'lucide-react';
import { references } from '../mock';

export const References = () => {
  const [selectedRef, setSelectedRef] = useState(null);

  return (
    <section id="references" className="py-20 bg-gray-950">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-yellow-500 font-semibold text-sm uppercase tracking-wider mb-3">
            Referenzen
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Unsere erfolgreich abgeschlossenen Projekte
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Überzeugen Sie sich von unserer Arbeit – hier eine Auswahl unserer Referenzprojekte.
          </p>
        </div>

        {/* References Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {references.map((ref) => (
            <div
              key={ref.id}
              className="group bg-gray-900 rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 border border-yellow-500/20 hover:border-yellow-500/50"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden cursor-pointer" onClick={() => setSelectedRef(ref)}>
                <img
                  src={ref.image}
                  alt={ref.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/70 to-transparent"></div>
                {/* Location Badge */}
                <div className="absolute top-4 left-4 flex items-center space-x-2 bg-yellow-500/90 backdrop-blur-sm px-3 py-1.5 rounded-full">
                  <MapPin className="w-4 h-4 text-gray-900" />
                  <span className="text-sm font-semibold text-gray-900">{ref.location}</span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-2 group-hover:text-yellow-400 transition-colors duration-300">
                  {ref.title}
                </h3>
                <p className="text-gray-300 leading-relaxed mb-4">{ref.description}</p>
                
                {/* Zur Galerie Button */}
                <button
                  onClick={() => window.location.href = '/galerie'}
                  className="inline-flex items-center space-x-2 text-yellow-500 font-semibold group-hover:text-yellow-400 transition-colors duration-300"
                >
                  <span>Zur Galerie</span>
                  <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Modal */}
        {selectedRef && (
          <div
            className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedRef(null)}
          >
            <div
              className="bg-gray-900 rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-auto border border-yellow-500/30"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                onClick={() => setSelectedRef(null)}
                className="absolute top-4 right-4 bg-gray-800 rounded-full p-2 hover:bg-gray-700 transition-colors duration-200 shadow-lg"
              >
                <X className="w-6 h-6 text-white" />
              </button>

              {/* Modal Content */}
              <img
                src={selectedRef.image}
                alt={selectedRef.title}
                className="w-full h-96 object-cover rounded-t-2xl"
              />
              <div className="p-8">
                <div className="flex items-center space-x-2 mb-4">
                  <MapPin className="w-5 h-5 text-yellow-500" />
                  <span className="text-yellow-500 font-semibold">{selectedRef.location}</span>
                </div>
                <h3 className="text-3xl font-bold text-white mb-4">{selectedRef.title}</h3>
                <p className="text-xl text-gray-300 leading-relaxed">{selectedRef.description}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};